<div class="modal-header" style="border-bottom: none !important;">
  <h2 class="modal-title">{{ title }}</h2>
</div>

<div class="modal-body" style="border-bottom: none !important;">

  @if (operationNumber || identifierNumber) {
    <div class="mb-3">
      @if (identifierNumber) {
        <div>
          <span>Documento:&nbsp;<strong>{{ identifierNumber }}</strong></span>
        </div>
      }
      @if (operationNumber) {
        <div>
          <span>Operación:&nbsp;<strong>{{ operationNumber }}</strong></span>
        </div>
      }
    </div>
  }

  <p>{{ message }}</p>

  <form class="mt-3">
    <div class="form-group">
      <input
        [(ngModel)]="dateValue"
        (ngModelChange)="onDateChange()"
        name="dateInput"
        type="date"
        class="form-control efx-input"
        id="dateInput"
        [placeholder]="placeholder"
        autocomplete="off">
        @if (errorMessage) {
          <small class="text-danger d-block mt-2">
            <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">error</span>
            {{ errorMessage }}
          </small>
        }
        <small class="text-muted d-block mt-1">Seleccione una fecha del calendario</small>
      </div>
    </form>
  </div>

  <div class="modal-footer" style="border-top: none !important;">
    <button type="button" class="efx-button-secondary button-secondary" (click)="decline()">
      {{ btnCancelText }}
    </button>
    <button type="button" class="efx-button-primary button-primary" (click)="accept()">
      {{ btnOkText }}
    </button>
  </div>